module.exports = __webpack_public_path__ + "static/media/elegirSucursar_imgMap.f2886b4f.svg";